const readingStatusStorage = {
    namespaced: true,

    state: {
        currentDate:'',
        scheduleDate:''
    },
    getters: {
        getDate(state) {
            return state.currentDate;
        },
        getReadingScheduleDate(state) {
            return state.scheduleDate;
        }
    },
    mutations: {
        updateDate(state, date) {
            state.currentDate = date;
        },
        updateReadingScheduleDate(state, date) {
            state.scheduleDate = date;
        },
    },
};
export default readingStatusStorage